// src/index.js - VERSÃO FINAL COM A CORREÇÃO DE TIMING APLICADA

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Verifica se estamos em ambiente de desenvolvimento
if (process.env.NODE_ENV === 'development') {
  /************************************************************
   * LÓGICA PARA DESENVOLVIMENTO LOCAL (`npm start`)
   * Carregamos explicitamente TODOS os estilos necessários aqui.
   ************************************************************/

  // Estilos globais
  require('./index.css');

  // Estilos dos componentes (um require para cada ficheiro .module.css)
  require('./components/ChatWidget.module.css');
  require('./components/ChatBody.module.css');
  require('./components/ChatInput.module.css');
  require('./components/TypingIndicator.module.css');
  require('./components/FeedbackActions.module.css');
  require('./components/FeedbackModal.module.css');
  require('./components/ResetButton.module.css');

  const container = document.getElementById('root');
  if (container) {
    const root = ReactDOM.createRoot(container);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }

} else {
  /*******************************************************************
   * LÓGICA PARA PRODUÇÃO (`npm run build`) - A NOSSA VERSÃO BLINDADA
   * Esta parte permanece a mesma e funcionará no WordPress.
   *******************************************************************/
  
  const HOST_ELEMENT_TAG = 'engehall-chat-host';
  const REACT_MOUNT_POINT_ID = 'react-chat-mount-point';
  const CHAT_CSS_LINK_ID = 'engehall-chat-styles-css';

  function initChat() {
    const hostElement = document.querySelector(HOST_ELEMENT_TAG);
    if (!hostElement) {
        console.error('ENGEHALL CHAT: O elemento anfitrião <engehall-chat-host> não foi encontrado no DOM.');
        return;
    };

    const shadowRoot = hostElement.attachShadow({ mode: 'open' });
    const mountPoint = document.createElement('div');
    mountPoint.id = REACT_MOUNT_POINT_ID;
    
    const chatStyles = document.getElementById(CHAT_CSS_LINK_ID);
    if (chatStyles) {
      shadowRoot.appendChild(chatStyles.cloneNode());
    }
    
    shadowRoot.appendChild(mountPoint);

    const root = ReactDOM.createRoot(mountPoint);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }

  // ==================================================================
  // CORREÇÃO DE TIMING APLICADA AQUI
  // Em vez de chamar initChat() imediatamente, esperamos que a página
  // inteira esteja carregada para garantir que a tag <engehall-chat-host> exista.
  // ==================================================================
  window.addEventListener('DOMContentLoaded', initChat);
}